<ng-container
  *ngIf="{
    channel: channel$ | async,
    channelStr: channelStr$ | async,
    skill: skill$ | async,
    active: active$ | async,
    canActive: canActive$ | async,
    dirty: dirty$ | async,
    index: index$ | async,
    slots: slots$ | async,
    underInstruction: underInstruction$ | async
  } as data"
>
  <th class="skillLabel" scope="row">
    <span class="nodisplay">{{ 'commons:basic.skill' | translate }}</span>
    {{ data.skill.name }}
    <span class="nodisplay">
      {{ 'commons:application.period.from' | translate }}
      {{ 'commons:basic.channel' | translate }}
      {{ 'commons:basic.channels.' + data.channelStr | translate }}
    </span>
  </th>

  <td cng-agent-planning-slot *ngFor="let slot of data.slots" [slot]="slot" [attr.colspan]="slot.total"></td>

  <td class="action">
    <label for="skillPlanning{{ data.index }}" class="nodisplay">
      {{ 'agent:general_information.skill_activation' | translate }}
      {{ data.skill.name }}
      {{ 'commons:application.period.from' | translate }}
      {{ 'commons:basic.channel' | translate }}
      {{ 'commons:basic.channels.' + data.channelStr | translate }}
    </label>
    <mat-slide-toggle
      [id]="'skillPlanning' + data.index"
      [checked]="data.active"
      [disabled]="data.dirty || data.underInstruction"
      *ngIf="data.canActive"
      (toggleChange)="toogleSkillActivation(!data.active)"
    >
    </mat-slide-toggle>
  </td>
</ng-container>
